import React, { forwardRef } from 'react';
import { func, shape, oneOf, string } from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../../.internal/BaseComponent';
import Icon from '../../icon/Icon';

import './LeafTrigger.scss';

const COLORS = [
  'accent',
  'default',
  'negative',
  'primary',
  'secondary',
  'warm',
  'white'
];

const colorClasses = {
  accent: '-accent',
  default: undefined,
  negative: '-negative',
  primary: '-primary',
  secondary: '-secondary',
  warm: '-warm',
  white: '-shade'
};

/**
 * @deprecated
 */
class LeafTrigger extends BaseComponent {
  render() {
    const { className, color, icon, id, onClick, style } = this.props;

    const classNames = ClassNames(
      'leaf-trigger',
      className,
      color && colorClasses[color]
    );

    return (
      <button
        type="button"
        className={classNames}
        icon={icon}
        id={id}
        onClick={onClick}
        style={style}
      >
        {typeof icon !== 'undefined' && (
          <Icon className="leaf-trigger-icon" icon={icon} size="sm" />
        )}
      </button>
    );
  }
}

LeafTrigger.propTypes = {
  className: string,
  icon: string,
  id: string,
  onClick: func,
  style: shape({}),
  color: oneOf(COLORS)
};

LeafTrigger.defaultProps = {
  className: undefined,
  icon: undefined,
  id: undefined,
  onClick: undefined,
  style: {}
};

export default forwardRef((props, ref) => <LeafTrigger {...props} ref={ref} />);
